var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 6.18327L12.3667 0.816602C12.6 0.583268 12.95 0.583268 13.1833 0.816602C13.4167 1.04993 13.4167 1.39994 13.1833 1.63327L7.81666 6.99994L13.1833 12.3666C13.4167 12.5999 13.4167 12.9499 13.1833 13.1833C12.95 13.4166 12.6 13.4166 12.3667 13.1833L6.99999 7.8166L1.63333 13.1833C1.39999 13.4166 1.04999 13.4166 0.81666 13.1833C0.583327 12.9499 0.583327 12.5999 0.81666 12.3666L6.18333 6.99994L0.699994 1.63327C0.466661 1.39994 0.466661 1.04993 0.699994 0.816602C0.933327 0.583268 1.28333 0.583268 1.51666 0.816602L6.99999 6.18327Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.f110707b3e5a6ad8713066fc85bbd1f1.svg";
export { ForwardRef as ReactComponent };